let audio,
    gameFrame,
    isFullscreen = false,
    gameData = {},
    timer = 0,
    timerInterval = null,
    moves = 0,
    maze = [],
    player = { x: 0, y: 0 },
    exit = { x: 0, y: 0 },
    obstacles = [],
    obstacleImages = [],
    backgroundImage = null,
    canvas = null,
    ctx = null,
    cellSize = 30,
    touchStartX = 0,
    touchStartY = 0;

class MazeGame {
    constructor() {
        this.playArea = document.querySelector('.game__maze-play');
        this.resultPhase = document.querySelector('[data-phase="result"]');
        this.timerEl = document.querySelector('[data-timer]');
        this.movesEl = document.querySelector('[data-moves]');
        this.canvas = document.getElementById('mazeCanvas');
        this.ctx = this.canvas.getContext('2d');

        // Pobierz dane z window
        if (window.mazeGameData) {
            gameData = window.mazeGameData;
        }

        canvas = this.canvas;
        ctx = this.ctx;

        this.init();
    }

    init() {
        this.setupCanvas();
        this.loadBackgroundImage();
        this.loadObstacleImages();
        this.generateMaze();
        this.drawMaze();
        this.setupControls();

        if (gameData.showTimer) {
            this.startTimer();
        }
    }

    loadBackgroundImage() {
        if (!gameData.customBackground) {
            return;
        }

        backgroundImage = new Image();
        backgroundImage.onload = () => {
            this.drawMaze();
        };
        backgroundImage.src = gameData.customBackground;
    }

    loadObstacleImages() {
        if (!gameData.obstacles || gameData.obstacles.length === 0) {
            return;
        }

        obstacleImages = [];
        let loadedCount = 0;
        const totalObstacles = gameData.obstacles.length;

        const checkComplete = () => {
            loadedCount++;
            if (loadedCount === totalObstacles) {
                // Usuń puste elementy z tablicy
                obstacleImages = obstacleImages.filter(img => img !== null);

                if (obstacleImages.length > 0) {
                    this.placeObstacles();
                }
                this.drawMaze();
            }
        };

        gameData.obstacles.forEach((url, index) => {
            if (!url || url === '') {
                obstacleImages[index] = null;
                checkComplete();
                return;
            }

            const img = new Image();

            img.onload = () => {
                checkComplete();
            };

            img.onerror = () => {
                console.warn('Nie udało się załadować przeszkody:', url);
                obstacleImages[index] = null;
                checkComplete();
            };

            img.src = url;
            obstacleImages[index] = img;
        });

        // Timeout na wypadek jeśli obrazki nie załadują się w ogóle
        setTimeout(() => {
            if (loadedCount < totalObstacles) {
                console.warn('Timeout ładowania przeszkód, kontynuowanie gry...');
                obstacleImages = obstacleImages.filter(img => img !== null);
                if (obstacleImages.length > 0) {
                    this.placeObstacles();
                }
                this.drawMaze();
            }
        }, 3000);
    }

    placeObstacles() {
        obstacles = [];
        if (obstacleImages.length === 0) return;

        const size = gameData.gridSize;
        const numObstacles = Math.floor(size * size * 0.1); // 10% komórek z przeszkodami

        for (let i = 0; i < numObstacles; i++) {
            let x, y;
            do {
                x = Math.floor(Math.random() * size);
                y = Math.floor(Math.random() * size);
            } while (
                (x === player.x && y === player.y) ||
                (x === exit.x && y === exit.y) ||
                obstacles.some(obs => obs.x === x && obs.y === y)
            );

            const imageIndex = Math.floor(Math.random() * obstacleImages.length);
            obstacles.push({ x, y, imageIndex });
        }
    }

    setupCanvas() {
        const container = document.querySelector('[data-maze-container]');
        const containerWidth = container.clientWidth;
        const containerHeight = container.clientHeight;

        // Oblicz rozmiar komórki tak, aby labirynt zmieścił się w kontenerze
        cellSize = Math.min(
            Math.floor(containerWidth / gameData.gridSize),
            Math.floor(containerHeight / gameData.gridSize)
        );

        this.canvas.width = cellSize * gameData.gridSize;
        this.canvas.height = cellSize * gameData.gridSize;
    }

    generateMaze() {
        const size = gameData.gridSize;

        // Inicjalizacja labiryntu (wszystkie ściany)
        maze = Array(size).fill().map(() => Array(size).fill().map(() => ({
            top: true,
            right: true,
            bottom: true,
            left: true,
            visited: false
        })));

        // Algorytm generowania labiryntu (Recursive Backtracker)
        const stack = [];
        const startX = Math.floor(Math.random() * size);
        const startY = Math.floor(Math.random() * size);

        let current = { x: startX, y: startY };
        maze[current.y][current.x].visited = true;
        stack.push(current);

        while (stack.length > 0) {
            current = stack[stack.length - 1];
            const neighbors = this.getUnvisitedNeighbors(current.x, current.y);

            if (neighbors.length > 0) {
                const next = neighbors[Math.floor(Math.random() * neighbors.length)];
                this.removeWall(current, next);
                maze[next.y][next.x].visited = true;
                stack.push(next);
            } else {
                stack.pop();
            }
        }

        // Ustaw gracza na losowej pozycji na brzegu
        const edge = Math.floor(Math.random() * 4); // 0=top, 1=right, 2=bottom, 3=left
        switch(edge) {
            case 0: player = { x: Math.floor(Math.random() * size), y: 0 }; break;
            case 1: player = { x: size - 1, y: Math.floor(Math.random() * size) }; break;
            case 2: player = { x: Math.floor(Math.random() * size), y: size - 1 }; break;
            case 3: player = { x: 0, y: Math.floor(Math.random() * size) }; break;
        }

        // Ustaw wyjście na przeciwległym brzegu
        switch(edge) {
            case 0: exit = { x: Math.floor(Math.random() * size), y: size - 1 }; break;
            case 1: exit = { x: 0, y: Math.floor(Math.random() * size) }; break;
            case 2: exit = { x: Math.floor(Math.random() * size), y: 0 }; break;
            case 3: exit = { x: size - 1, y: Math.floor(Math.random() * size) }; break;
        }
    }

    getUnvisitedNeighbors(x, y) {
        const neighbors = [];
        const size = gameData.gridSize;

        if (y > 0 && !maze[y - 1][x].visited) neighbors.push({ x, y: y - 1, dir: 'top' });
        if (x < size - 1 && !maze[y][x + 1].visited) neighbors.push({ x: x + 1, y, dir: 'right' });
        if (y < size - 1 && !maze[y + 1][x].visited) neighbors.push({ x, y: y + 1, dir: 'bottom' });
        if (x > 0 && !maze[y][x - 1].visited) neighbors.push({ x: x - 1, y, dir: 'left' });

        return neighbors;
    }

    removeWall(current, next) {
        const dx = next.x - current.x;
        const dy = next.y - current.y;

        if (dx === 1) {
            maze[current.y][current.x].right = false;
            maze[next.y][next.x].left = false;
        } else if (dx === -1) {
            maze[current.y][current.x].left = false;
            maze[next.y][next.x].right = false;
        } else if (dy === 1) {
            maze[current.y][current.x].bottom = false;
            maze[next.y][next.x].top = false;
        } else if (dy === -1) {
            maze[current.y][current.x].top = false;
            maze[next.y][next.x].bottom = false;
        }
    }

    drawMaze() {
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        // Rysuj tło jeśli jest ustawione
        if (backgroundImage && backgroundImage.complete) {
            ctx.drawImage(backgroundImage, 0, 0, canvas.width, canvas.height);
        }

        // Rysuj komórki labiryntu
        for (let y = 0; y < gameData.gridSize; y++) {
            for (let x = 0; x < gameData.gridSize; x++) {
                const cell = maze[y][x];
                const px = x * cellSize;
                const py = y * cellSize;

                // Tło komórki tylko jeśli nie ma własnego tła
                if (!backgroundImage || !backgroundImage.complete) {
                    ctx.fillStyle = this.getThemeColor('floor');
                    ctx.fillRect(px, py, cellSize, cellSize);
                }

                // Ściany
                ctx.strokeStyle = this.getThemeColor('wall');
                ctx.lineWidth = 2;

                ctx.beginPath();
                if (cell.top) {
                    ctx.moveTo(px, py);
                    ctx.lineTo(px + cellSize, py);
                }
                if (cell.right) {
                    ctx.moveTo(px + cellSize, py);
                    ctx.lineTo(px + cellSize, py + cellSize);
                }
                if (cell.bottom) {
                    ctx.moveTo(px, py + cellSize);
                    ctx.lineTo(px + cellSize, py + cellSize);
                }
                if (cell.left) {
                    ctx.moveTo(px, py);
                    ctx.lineTo(px, py + cellSize);
                }
                ctx.stroke();
            }
        }

        // Rysuj wyjście
        ctx.fillStyle = this.getThemeColor('exit');
        ctx.fillRect(exit.x * cellSize + 5, exit.y * cellSize + 5, cellSize - 10, cellSize - 10);

        // Rysuj przeszkody
        if (obstacles && obstacles.length > 0) {
            obstacles.forEach(obstacle => {
                const img = obstacleImages[obstacle.imageIndex];
                if (img && img.complete && img.naturalWidth > 0) {
                    const padding = 5;
                    try {
                        ctx.drawImage(
                            img,
                            obstacle.x * cellSize + padding,
                            obstacle.y * cellSize + padding,
                            cellSize - padding * 2,
                            cellSize - padding * 2
                        );
                    } catch (e) {
                        console.error('Błąd rysowania przeszkody:', e);
                    }
                } else {
                    // Rysuj placeholder jeśli obrazek nie załadował się
                    ctx.fillStyle = 'rgba(255, 0, 0, 0.3)';
                    ctx.fillRect(
                        obstacle.x * cellSize + 5,
                        obstacle.y * cellSize + 5,
                        cellSize - 10,
                        cellSize - 10
                    );
                }
            });
        }

        // Rysuj gracza
        ctx.fillStyle = this.getThemeColor('player');
        ctx.beginPath();
        ctx.arc(
            player.x * cellSize + cellSize / 2,
            player.y * cellSize + cellSize / 2,
            cellSize / 3,
            0,
            Math.PI * 2
        );
        ctx.fill();
    }

    getThemeColor(element) {
        const themes = {
            classic: {
                wall: '#2c3e50',
                floor: '#ecf0f1',
                player: '#3498db',
                exit: '#2ecc71'
            },
            forest: {
                wall: '#27ae60',
                floor: '#d5f4e6',
                player: '#e74c3c',
                exit: '#f39c12'
            },
            castle: {
                wall: '#7f8c8d',
                floor: '#bdc3c7',
                player: '#e67e22',
                exit: '#9b59b6'
            },
            space: {
                wall: '#34495e',
                floor: '#2c3e50',
                player: '#1abc9c',
                exit: '#f1c40f'
            }
        };

        return (themes[gameData.theme] && themes[gameData.theme][element]) || themes.classic[element];
    }

    setupControls() {
        // Klawiatura
        document.addEventListener('keydown', (e) => {
            if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(e.key)) {
                e.preventDefault();
                this.handleMove(e.key);
            }
        });

        // Touch
        canvas.addEventListener('touchstart', (e) => {
            touchStartX = e.touches[0].clientX;
            touchStartY = e.touches[0].clientY;
        });

        canvas.addEventListener('touchend', (e) => {
            const touchEndX = e.changedTouches[0].clientX;
            const touchEndY = e.changedTouches[0].clientY;
            const dx = touchEndX - touchStartX;
            const dy = touchEndY - touchStartY;

            if (Math.abs(dx) > Math.abs(dy)) {
                this.handleMove(dx > 0 ? 'ArrowRight' : 'ArrowLeft');
            } else {
                this.handleMove(dy > 0 ? 'ArrowDown' : 'ArrowUp');
            }
        });
    }

    handleMove(direction) {
        const cell = maze[player.y][player.x];
        let newX = player.x;
        let newY = player.y;

        switch(direction) {
            case 'ArrowUp':
                if (!cell.top) newY--;
                break;
            case 'ArrowDown':
                if (!cell.bottom) newY++;
                break;
            case 'ArrowLeft':
                if (!cell.left) newX--;
                break;
            case 'ArrowRight':
                if (!cell.right) newX++;
                break;
        }

        if (newX !== player.x || newY !== player.y) {
            player.x = newX;
            player.y = newY;
            moves++;
            this.movesEl.textContent = moves;
            this.drawMaze();

            // Sprawdź czy gracz dotarł do wyjścia
            if (player.x === exit.x && player.y === exit.y) {
                this.gameComplete();
            }
        }
    }

    startTimer() {
        timerInterval = setInterval(() => {
            timer++;
            const minutes = Math.floor(timer / 60);
            const seconds = timer % 60;
            this.timerEl.textContent = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

            // Sprawdź limit czasu
            if (gameData.timeLimit > 0 && timer >= gameData.timeLimit) {
                this.gameOver();
            }
        }, 1000);
    }

    stopTimer() {
        if (timerInterval) {
            clearInterval(timerInterval);
            timerInterval = null;
        }
    }

    gameComplete() {
        this.stopTimer();

        const minutes = Math.floor(timer / 60);
        const seconds = timer % 60;
        const timeStr = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

        document.querySelector('[data-final-time]').textContent = timeStr;
        document.querySelector('[data-final-moves]').textContent = moves;

        this.playArea.classList.add('hidden');
        this.resultPhase.classList.remove('hidden');
    }

    gameOver() {
        this.stopTimer();
        alert('Czas minął! Spróbuj ponownie.');
        this.restart();
    }

    restart() {
        timer = 0;
        moves = 0;
        this.stopTimer();

        if (this.timerEl) this.timerEl.textContent = '00:00';
        if (this.movesEl) this.movesEl.textContent = '0';

        this.playArea.classList.remove('hidden');
        this.resultPhase.classList.add('hidden');

        this.generateMaze();
        if (obstacleImages.length > 0) {
            this.placeObstacles();
        }
        this.drawMaze();

        if (gameData.showTimer) {
            this.startTimer();
        }
    }
}

// Inicjalizacja gry po załadowaniu DOM
document.addEventListener('DOMContentLoaded', function () {
    if (typeof window.mazeGameData !== 'undefined') {
        const game = new MazeGame();

        // Restart gry
        document.querySelectorAll('[data-game-restart]').forEach(btn => {
            btn.addEventListener('click', () => game.restart());
        });

        // Powrót
        document.querySelectorAll('[data-backward]').forEach(btn => {
            btn.addEventListener('click', () => window.history.back());
        });

        // Fullscreen
        document.querySelectorAll('[data-toggle-fullscreen]').forEach(btn => {
            btn.addEventListener('click', () => {
                const frame = document.querySelector('.game__frame');
                if (!document.fullscreenElement) {
                    frame.requestFullscreen();
                } else {
                    document.exitFullscreen();
                }
            });
        });
    }
});

export default {
    initGame: () => {
        // Inicjalizacja jest w DOMContentLoaded powyżej
    }
};




// WEBPACK FOOTER //
// ./src/scripts/game-maze.js